import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=b2283ab4&scoped=true&"
import script from "./GridView.vue?vue&type=script&lang=js&"
export * from "./GridView.vue?vue&type=script&lang=js&"
import style0 from "./GridView.vue?vue&type=style&index=0&id=b2283ab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2283ab4",
  null
  
)

export default component.exports